var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.previousStage)?_c('button',{class:_vm.twStyle,attrs:{"type":"button"},on:{"click":function($event){return _vm.navigateBack()}}},[_c('font-awesome-icon',{attrs:{"icon":"chevron-left"}}),_vm._v(" "),_c('span',[_vm._v("\n          Go Back\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }